<!-- <div>
<i nz-icon nzType="idcard" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">Menu Profile</b>
</div> -->

<pg-header
  title="Menu Profile"
  ticon="idcard"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div class="ds-card grid">
  <app-data-grid
    id="gridContainer"
    style="width: 100%"
    [dataSource]="mnuprflLst"
    [legacyColumns]="columnDefs"
    [searchPanel]="true"
    [filterRow]="true"
    [filterPanel]="true"
    [groupPanel]="true"
    [columnChooser]="true"
    [allowExport]="true"
    exportFileName="LMO Details"
    [pageSize]="10"
    [allowedPageSizes]="[10, 25, 50, 100]"
    [showPageSizeSelector]="true"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
  >
    <app-grid-column
      [showInColumnChooser]="false"
      type="buttons"
      [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
      [width]="100"
      caption="Edit"
      cellTemplate="editTemplate"
    ></app-grid-column>
    <ng-template appGridCell="editTemplate" let-data="cell"
      ><div>
        <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
      </div></ng-template
    >
    <app-grid-column
      [showInColumnChooser]="false"
      [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
      type="buttons"
      [width]="100"
      caption="Delete"
      cellTemplate="delTemplate"
    ></app-grid-column>
    <ng-template appGridCell="delTemplate" let-data="cell"
      ><div>
        <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
      </div></ng-template
    >
  </app-data-grid>
</div>
}
<nz-drawer
  [nzBodyStyle]="{
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    'padding-bottom': '53px'
  }"
  [nzMaskClosable]="false"
  [nzWidth]="370"
  [nzVisible]="shwSidebar"
  [nzTitle]="sidebarHeading"
  (nzOnClose)="closeSideBar()"
>
  <form nz-form [formGroup]="mnuprflForm">
    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="mnuprflMrgn"
      >
        <div class="inptLbl">Menu Profile Name</div>
        <input type="text" nz-input formControlName="prfle_nm" />
      </div>
    </div>
    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="mnuprflMrgn"
      >
        <div class="inptLbl">Menu Profile Description</div>
        <input type="text" nz-input formControlName="prfle_dscrn_tx" />
      </div>
    </div>
    <div class="input-row" nz-row>
      <div
        nz-col
        nzXs="24"
        nzSm="24"
        nzMd="24"
        nzLg="24"
        nzXl="24"
        class="mnuprflMrgn"
      >
        <div class="inptLbl">Select Component Name</div>
        <nz-select
          style="width: 100%"
          nzPlaceHolder="Select Component Name"
          formControlName="cmpnt_nm"
        >
          @for (c of cmpnt_lst; track c) {
          <nz-option [nzValue]="c.cmpnt_id" [nzLabel]="c.cmpnt_nm"> </nz-option>
          }
        </nz-select>
      </div>
    </div>
  </form>
  <div class="ds-card grid">
    <div class="stpoptsmainhng">Menu Options</div>
    <ul class="stpopts" nz-list [nzDataSource]="mnuoptnlst" nzBordered>
      <div>
        @for (m of mnuoptnlst; track m) {
        <li nz-list-item nzNoFlex>
          <ul nz-list-item-actions>
            <nz-list-item-action>
              <label
                nz-checkbox
                [(ngModel)]="m.isActive"
                (ngModelChange)="ischeked($event, m)"
              ></label>
            </nz-list-item-action>
          </ul>
          {{ m.mnu_itm_nm }}
        </li>
        }
      </div>
    </ul>
  </div>
  @if (shwschvlymEditDiv==false && shwschvlymDelDiv==false) {
  <button nz-button nzType="primary" class="sbmtBtm" (click)="savemnuprfl()">
    Submit
  </button>
  } @if (shwschvlymEditDiv==true && shwschvlymDelDiv==false) {
  <button nz-button nzType="primary" class="sbmtBtm" (click)="updtmnuprfl()">
    Update
  </button>
  } @if (shwschvlymEditDiv==false && shwschvlymDelDiv==true) {
  <button
    nz-button
    nzType="primary"
    class="sbmtBtm"
    nz-popconfirm
    nzPopconfirmTitle="Are you sure deleting this profile?"
    [nzIcon]="iconTpl"
    nzPopconfirmPlacement="left"
    [nzPopconfirmShowArrow]="false"
    (nzOnConfirm)="deletemnufun()"
    nzOkType="danger"
    nzOkText="YES"
    nzCancelText="NO"
    (nzOnCancel)="cancel()"
  >
    Delete
  </button>
  }
  <button nz-button nzType="default" class="cnclBtn" (click)="cancelbtn()">
    Cancel
  </button>
  <ng-template #iconTpl>
    <i nz-icon nzType="question-circle-o" style="color: red"></i>
  </ng-template>
</nz-drawer>
@if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
  </nz-result>
</div>
}
